import { render, staticRenderFns } from "./01_GeneralInfoForm.vue?vue&type=template&id=fb8545ac&"
import script from "./01_GeneralInfoForm.vue?vue&type=script&lang=js&"
export * from "./01_GeneralInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports